import { CASSubtypes } from '../../../cimsPage/instances/cas'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const subtypes = CreateViewEditSoftRemoveRestore({
  object: 'Subtype',
  page: CASSubtypes,
  create: '52D6CB52-9B7C-4D2D-8F3B-420A0CAB0253',
  view: '14DC4586-1F6E-4449-A35B-F2368442E80F',
  edit: '19054A5C-5D63-4E13-9692-CC62F0A25E36',
  removeRestore: 'C7352F99-E077-4375-8A1B-002174ECE61D',
})

export const CreateCASSubtype = subtypes.Create
export const ViewCASSubtype = subtypes.View
export const EditCASSubtype = subtypes.Edit
export const RemoveRestoreCASSubtype = subtypes.RemoveRestore

export type CASSubtypePermission =
  | typeof CreateCASSubtype
  | typeof ViewCASSubtype
  | typeof EditCASSubtype
  | typeof RemoveRestoreCASSubtype
